const wm = {};

wm.slug = '';


/**
 *
 * Build Tools for Building DOM Elements
 *
 */

wm.build = {};

/**
 *
 * Helper method to do a replace all in a string using the provided regex
 *
 * @param {regex} regex The pattern to look for to replace
 * @param {String} replaceWith The string to put in the place of matching items
 * @param {String} str The string the regex pattern will search in
 * @returns {unresolved}
 */

wm.build._replaceAll = function(regex, replaceWith, str) {
	return str.replace(new RegExp(regex, 'g'), replaceWith);
};

/**
 *
 * Builds a element node with no attributes and some display text
 *
 * @param {String} elementType
 * @param {String} displayValue
 * @returns {Element}
 */
wm.build.elementWithText = function (elementType, displayValue) {
	var element = document.createElement(elementType);
	element.appendChild(document.createTextNode(displayValue));
	return element;
};

/**
 *
 * Generic function that will build an element with optional displayText
 * and add attributes to the element based on the map using the map.key
 * as the attribute name and the map.value as the attributes value
 *
 * @param {string} elementToMake
 * @param {Object} elementAttributes
 * @param {string} displayText
 * @returns {Element}
 * example: wm.build.elementWithAttributes('div', {class: "foo", id: "faa"}, 'bar');
 */
wm.build.elementWithAttributes = function(elementToMake, elementAttributes, displayText) {
	var element = document.createElement(elementToMake);

	for (var prop in elementAttributes) {
		element.setAttribute(prop, elementAttributes[prop]);
	}

	if (displayText || displayText === 0) {
		element.appendChild(document.createTextNode(displayText));
	}
	return element;
};


/**
 *
 * Generic function that will place an element within a specified container
 */
wm.build.place = function(element, container) {
	container = document.querySelector(container);
	container.appendChild(element);
};

wm.build.escapeChars = { lt: '<', gt: '>', quot: '"', apos: "'", amp: '&' };

wm.build.unescapeHTML = function(str) {//modified from underscore.string and string.js
    return str.replace(/\&([^;]+);/g, function(entity, entityCode) {
        var match;

        if ( entityCode in wm.build.escapeChars) {
            return wm.build.escapeChars[entityCode];
        } else if ( match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
            return String.fromCharCode(parseInt(match[1], 16));
        } else if ( match = entityCode.match(/^#(\d+)$/)) {
            return String.fromCharCode(~~match[1]);
        } else {
            return entity;
        }
    });
};


/**
 *
 * Generic function that will wrap and element with an element
 *
 * @param {Object} element
 * @param {string} container
 * example: wm.build.wrap(document.querySelector('.wrap-me'), document.createElement('div'), 'wrapper');
 */

wm.build.wrap = function(element, wrapper) {
	element.parentNode.insertBefore(wrapper, element);
	wrapper.appendChild(element);
};
/**
 *
 * AJAX Tools
 * https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
 * https://developer.mozilla.org/en-US/docs/AJAX/Getting_Started
 *
 */

wm.ajax = {};

/**
 *
 * wm.ajax.get
 * @param {string} url : path to endpoint
 * @param {object} params : params to send in URL
 * @callback {function} callback to run when readyState == 4
 *
 */

wm.ajax.get = function(url, params, callback) {

	var customHeaders = false;
	var customResponseType = false;

	if (typeof params == 'object') {

		// Check for setRequestHeader in params
		if ('setRequestHeader' in params) {
			customHeaders = params.setRequestHeader;
			delete params['setRequestHeader'];
		}

		// Check for responseType in params
		if ('responseType' in params) {
			customResponseType = params.responseType;
			delete params['responseType'];
		}
	} // object check

	// Send Params to String
	var str = '';
	if (typeof params == 'object') {
		// loop through objects/keys
		for (var key in params) {
			if (str != '') {
				str += '&';
			}
			str += key + '=' + encodeURIComponent(params[key]);
		}
	};

	if (str.length >= 1) url = url.concat('?', str);

	// start xmlhttprequest
 	var xhr = new XMLHttpRequest();

	// xhr.withCredentials = true;

	if (customResponseType) {
		xhr.responseType = customResponseType;
	}
	else {
		xhr.responseType = 'json';
	}


	xhr.addEventListener('readystatechange', function () {
		if (this.readyState === this.DONE) {
			if (typeof callback == 'function') callback(xhr);
		}
	});

	xhr.open('GET', url);
	// xhr.timeout = 6000;

	// Normal Headers
	xhr.setRequestHeader('content-type', 'application/JSON');
	xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
	// Custom Headers
	if (customHeaders) {
		for (var header in customHeaders) {
			xhr.setRequestHeader(header, customHeaders[header]);
		}
	}

	xhr.send();
};
// ====================================================
// GLOBAL SELECTORS
// ====================================================
wm.globalheader = document.querySelector('header');
wm.globalnav = document.querySelector('header nav');
wm.scene = document.querySelector('section.scene');

// ====================================================
// IOS SAFARI CHECK
// ====================================================
wm.iosCheck = function() {
	var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
	var isIphone = /(iPhone)/i.test(navigator.userAgent);
	var isIpad = /(iPad)/i.test(navigator.userAgent);

	if (isSafari && (isIphone || isIpad)) {
		wm.scene.classList.add('ios');
	}
}();


// ====================================================
// NAV FLY
// ====================================================

wm.navfly = {};
wm.navfly.container = document.querySelector('nav.fly');
wm.navfly.btn = {
	'open': document.querySelector('button.globalmenu--open'),
	'close': document.querySelector('button.globalmenu--close')
};

if (wm.navfly.container != null) {

	wm.navfly.open = function(action) {
		wm.navfly.container.classList.remove('closed');
	};

	wm.navfly.close = function(action) {
		wm.navfly.container.classList.add('closed');
	};

	// NAV FLY LISTNERS
	wm.navfly.btn.open.addEventListener('click', wm.navfly.open, false);
	wm.navfly.btn.close.addEventListener('click', wm.navfly.close, false);

	// Check for click outside of container when open
	document.addEventListener('click', function(e) {
		var navzone = (document.body.clientWidth - wm.navfly.container.clientWidth);
		if (!wm.navfly.container.classList.contains('closed')
			&& e.clientX < navzone
			&& e.target.nodeName !== 'BUTTON') {
			e.preventDefault();
			wm.navfly.close();
		}
	}, false);
	// Check for ESC while open
	document.addEventListener('keyup', function(e) {
		if (!wm.navfly.container.classList.contains('closed') && e.keyCode == 27) {
			wm.navfly.close();
		}
	}, false);

	// NAV FLY INIT --- Now closed by default
	// wm.navfly.close();
};


// ====================================================
// SEARCH ACTIONS
// ====================================================


wm.srch = {}
wm.srch.searchbox = document.querySelector('form.searchbox');
wm.srch.searchinput = document.querySelector('form.searchbox input[type="search"]');
wm.srch.btn = {}
wm.srch.btn.open = document.querySelector('button.searchbox--open');
wm.srch.btn.close = document.querySelector('button.searchbox--close');

if (wm.srch.searchbox != null) {

	wm.srch.open = function(action) {
		wm.srch.searchbox.classList.remove('closed');
		wm.srch.btn.open.classList.add('closed');
		wm.srch.btn.close.classList.remove('closed');
		wm.globalnav.classList.add('search--active');
		wm.srch.searchinput.focus();
	};

	wm.srch.close = function(action) {
		wm.srch.searchbox.classList.add('closed');
		wm.srch.btn.open.classList.remove('closed');
		wm.srch.btn.close.classList.add('closed');
		setTimeout(function () {
			wm.globalnav.classList.remove('search--active');
		}, 300);		
	};

	// SEARCH LISTENERS
	wm.srch.btn.open.addEventListener('click', wm.srch.open, false);
	wm.srch.btn.close.addEventListener('click', wm.srch.close, false);

	// SEARCH INIT
	wm.srch.close();

};



// ====================================================
// ACCORDION
// ====================================================

wm.accordion = {};

wm.accordion.containers = document.querySelectorAll('.accordion');

wm.accordion.init = function() {
	for (var i = 0; i < wm.accordion.containers.length; i++) {
		var accTitle = wm.accordion.containers[i].children[0];
		accTitle.addEventListener('click', wm.accordion.toggle, false);
	}
};

wm.accordion.toggle = function(e) {
	var container = e.currentTarget.parentElement;
	var view = container.dataset.view;

	if (view === 'closed') {
		container.dataset.view = 'open';
	}
	else if (view === 'open') {
		container.dataset.view = 'closed';	
	}
};

if (wm.accordion.containers.length >= 1) wm.accordion.init();


// ====================================================
// GALLERY WIDGET MODIFIER
// ====================================================

wm.gallery = {};

wm.gallery.containers = document.querySelectorAll('.widget .gallery');

wm.gallery.init = function() {
	for(var i = 0, length1 = wm.gallery.containers.length; i < length1; i++){
		wm.gallery.setBgs(wm.gallery.containers[i]);
	}
};

wm.gallery.setBgs = function(gallery) {
	var items = gallery.querySelectorAll('.gallery-item');
	
	for(var i = 0, length1 = items.length; i < length1; i++){
		var item = items[i];
		console.log(item);
		var img = item.querySelector('img');
		var imgsrc = img.src;
		var icon = item.querySelector('.gallery-icon');
		var caption  = item.querySelector('.gallery-caption');
		var href = item.querySelector('a');;
		wm.gallery.setHref(caption, href);
	}

};

wm.gallery.setHref = function(el, url) {
	if (el) {
		el.classList.add('caption-haslink');
		el.addEventListener('click', function(){
			window.location = url;
		}, false);
	}
};

if (wm.gallery.containers.length >= 1) {
	wm.gallery.init();	
}

/* ##################################################################
	MODALS
################################################################## */

wm.modal = {};

/**
 *
 * Modal Elements
 * 
 */

var closeBtns = document.querySelectorAll('button.modal-close');

/**
 *
 * Init Modals
 * 
 */

wm.modal.init = function() {

	// Destroy Listener
	if (closeBtns.length >= 1) {
		for (var i = 0, length1 = closeBtns.length; i < length1; i++) {
			closeBtns[i].addEventListener('click', wm.modal.destroy, false);
		}
	}
};

/**
 *
 * Destroy All Modals and Overlays
 * 
 */

wm.modal.destroy = function() {
	var modals = document.querySelectorAll('.modal');
	var overlays = document.querySelectorAll('.modal-overlay');
	for (var i = 0; i < modals.length; i++) {
		modals[i].parentNode.removeChild(modals[i]);
	}
	for (var i = 0; i < overlays.length; i++) {
		overlays[i].parentNode.removeChild(overlays[i]);
	}
};

wm.modal.init();
/* ##################################################################
	BANNERS
################################################################## */

wm.banner = {};

/**
 *
 * Banner Elements
 * 
 */

wm.banner.closeBtns = document.querySelectorAll('button.banner-close');

/**
 *
 * Init Banner
 * 
 */

wm.banner.init = function() {

	// Destroy Listener
	if (wm.banner.closeBtns.length >= 1) {
		for (var i = 0, length1 = wm.banner.closeBtns.length; i < length1; i++) {
			wm.banner.closeBtns[i].addEventListener('click', wm.banner.destroy, false);
		}
	}	
};

/**
 *
 * Destroy All Banners
 * 
 */

wm.banner.destroy = function(e) {

	var modals = document.querySelectorAll('.banner');
	for (var i = 0; i < modals.length; i++) {
		modals[i].parentNode.removeChild(modals[i]);
	}

	
};

wm.banner.init();
/* ##################################################################
	NOTICES EXTRA METHODS
################################################################## */

wm.notice = {};

/**
 *
 * Notification Elements
 * 
 */

wm.notice.closeBtns = document.querySelectorAll('button.banner-close, button.modal-close');

wm.notice.current = document.querySelector('.ui-notice');
wm.notice.currentOverlay = document.querySelector('.modal-overlay');

/**
 *
 * Init Notification Listeners / Etc
 * 
 */

wm.notice.init = function() {

	// Check for dismissals
	if (wm.notice.current && !wm.notice.checkDismissal()) {
		console.log('banner has NOT been dismissed');
		wm.notice.current.classList.remove('hidden');

		if (wm.notice.currentOverlay) wm.notice.currentOverlay.classList.remove('hidden');
	}

	// Dismiss Listener
	if (wm.notice.closeBtns.length >= 1) {
		for (var i = 0, length1 = wm.notice.closeBtns.length; i < length1; i++) {
			wm.notice.closeBtns[i].addEventListener('click', wm.notice.dismiss, false);
		}
	}
};

/**
 *
 * Check for Dismissed Banners
 * 
 */

wm.notice.checkDismissal = function() {
	
	// check the id for an existing dismissal
	var currentId = 'notice_' + wm.notice.current.dataset.noticeid;
	var dismissedId = sessionStorage.getItem(currentId);

	if (dismissedId == 'dismissed') {
		return true;
	}
	else {
		return false;
	}

};

/**
 *
 * Dismissals
 * 
 */

wm.notice.dismiss = function(e) {
	// Add dismissed to sessionStorage
	if (wm.notice.current) {
		var noticeId = 'notice_' + wm.notice.current.dataset.noticeid;
		sessionStorage.setItem(noticeId, 'dismissed');
	}
};

wm.notice.init();
var cal = {};
	// cal.eventsurl = '/calendar/restfeeds/';
	cal.eventsurl =  wm.slug;
	cal.containers = document.querySelectorAll('.calevents');

cal.init = function() {

	for (var i = 0; i < cal.containers.length; i++) {
		var args = {};
			args.container = cal.containers[i];
			args.eventhtml = '';
			args.calargs = {};
			args.calargs.s = ''; // required to set search
			args.calargs.type = 'events';
			args.calargs.results = 'events';
			if (cal.containers[i].dataset.category) args.calargs.category = cal.containers[i].dataset.category;
			if (cal.containers[i].dataset.categoryname) args.calargs.categoryname = cal.containers[i].dataset.categoryname;
			if (cal.containers[i].dataset.excerpt) args.calargs.excerpt = cal.containers[i].dataset.excerpt;
			if (cal.containers[i].dataset.month) args.calargs.month = cal.containers[i].dataset.month;
			args.calargs.limit = cal.containers[i].dataset.limit;
		// Show Loadmore if Avail
		cal.loadmore.show(args.container, 'more');
		// Show Lazy Load
		cal.showloading(args);
	} // for

};



cal.showloading = function(args) {
	var loadingitems = 3;
	var loadinghtml = '<a class="cal-item loading"><div class="cal-meta"><span class="cal-month"></span><span class="cal-day"></span></div><div class="cal-entry"><h3 class="cal-title"></h3><p class="cal-desc"></p><p class="cal-location"></p><p class="cal-time"></p></div></a>';
	for (var i = 0; i < loadingitems; i++) {
		args.container.insertAdjacentHTML('beforeend', loadinghtml);
	}
	cal.get(args);
};

cal.noneavailable = function(args) {
	var loadinghtml = '<div class="cal-noevents">No events currently available</div>';
	args.container.innerHTML = '';
	args.container.insertAdjacentHTML('beforeend', loadinghtml);

	cal.loadmore.hide(args.container, 'more');
};

cal.get = function(args) {

	wm.ajax.get(cal.eventsurl, args.calargs, function(res) {
		if (res.response != null) {
			cal.parse(res.response, args);
		}
	});
};

cal.convertDate = function(date) {
	//convert from yymmdd to Month dd yy
	var monthNames = ['','January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	var datesplit = date.split('-');
	var month = datesplit[1].replace(/^0+/, '');
	date = monthNames[month] + ' ' + datesplit[2] + ', ' + datesplit[0];
	return date;
};

cal.parseDateTime = function(date) {
	var monthNames = ['','January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		pdate = new Date(date),
		pmonth = monthNames[pdate.getMonth() + 1],
		pday = pdate.getDate(),
		pyear = pdate.getFullYear(),
		phours = pdate.getHours(),
		pminutes = pdate.getMinutes(),
		ampm = phours >= 12 ? 'pm' : 'am',
		phours = phours % 12,
		phours = phours ? phours : 12,
		pminutes = pminutes < 10 ? '0'+pminutes : pminutes,
		ptime = phours + ':' + pminutes + ' ' + ampm;
	return (pmonth + ' ' + pday + ', ' + pyear + ' @ ' + ptime);
};

cal.parseMonth = function(date) {
	var monthNames = ['','Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		pdate = new Date(date),
		pmonth = monthNames[pdate.getMonth() + 1];
	return pmonth;
};

cal.parseDay = function(date) {
	var pdate = new Date(date),
		pday = pdate.getDate();
	return pday;
};

cal.parseTime = function(date) {
	var pdate = new Date(date),
		phours = pdate.getHours(),
		pminutes = pdate.getMinutes(),
		ampm = phours >= 12 ? 'pm' : 'am',
		phours = phours % 12,
		phours = phours ? phours : 12,
		pminutes = pminutes < 10 ? '0'+pminutes : pminutes,
		ptime = phours + ':' + pminutes + ' ' + ampm;
	return ptime;
};

cal.trimText = function(text, limit) {
	if (!limit) limit = 300;
	if (text.length >= limit) {
		var trimmedText = text.substring(0, limit);
		return trimmedText.concat(' [...]');
	} else {
		return text;
	}
	
}

cal.parse = function(data, args){
	var items = data.data;
	
	// IF IE11
	if (typeof items == 'string') {
		items = JSON.parse(items);
	}
	
	if (items.length != 0 && args.calargs.limit >= 1) {

		args.container.innerHTML = '';

		for (var i = 0; i < items.length; i++) {

			var link = items[i].url,
				title = items[i].title,
				desc = items[i].desc,
				location = items[i].location,
				date = items[i].date,
				dateicon = date.split(/\s+/),
				year = items[i].year;

			var nItem = wm.build.elementWithAttributes('a', {class: "cal-item", href: link}, null);
			var nItemEntry = wm.build.elementWithAttributes('div', {class: "cal-entry"}, null);
			var nItemTitle = wm.build.elementWithAttributes('h3', {class: "cal-title"}, wm.build.unescapeHTML(title));
			if (desc && args.calargs.excerpt == 'true') var nItemDesc = wm.build.elementWithAttributes('p', {class: "cal-desc"}, wm.build.unescapeHTML(cal.trimText(desc)));
			if (location) var nItemLocation = wm.build.elementWithAttributes('p', {class: "cal-location"}, location);
			
			if (date) {
				nItemTime = wm.build.elementWithAttributes('p', {class: "cal-time"}, date);
				nItemMonth = wm.build.elementWithAttributes('span', {class: "cal-month"}, dateicon[0]);
				nItemDay = wm.build.elementWithAttributes('span', {class: "cal-day"}, dateicon[1]);
			}

			// Meta Container
			var nItemMeta = wm.build.elementWithAttributes('div', {class: "cal-meta"}, null);
			// Build Meta Month/Date
			nItemMeta.appendChild(nItemMonth);
			nItemMeta.appendChild(nItemDay);
			// ...
			nItem.appendChild(nItemMeta);
			// Append Entry Container
			nItem.appendChild(nItemEntry);
			// ...
			nItemEntry.appendChild(nItemTitle);
			if (desc && args.calargs.excerpt == 'true') nItemEntry.appendChild(nItemDesc);
			if (location) nItemEntry.appendChild(nItemLocation);
			nItemEntry.appendChild(nItemTime);
			// Final Append
			args.container.appendChild(nItem);
		}

		if (items.length < args.calargs.limit) {
			cal.loadmore.hide(args.container, 'more');
		}

	} else {
		cal.noneavailable(args);
	}
};


/* ##################################################################
	LOAD MORE CALENDAR FUNCTIONS
################################################################## */

// LOAD MORE FUNCTIONS
cal.loadmore = {};
cal.loadmore.btn = document.querySelectorAll('.calevents-loadmore .loadmore');

cal.loadmore.init = function(e) {
	var targetBtn = e.currentTarget;
	var eventsTarget = targetBtn.parentNode.previousSibling;

	if (targetBtn.dataset.type == 'more') {
		var targetLimit = parseInt(eventsTarget.dataset.limit);
		if (!eventsTarget.dataset.defaultlimit) {
			eventsTarget.dataset.defaultlimit = targetLimit;
			eventsTarget.dataset.limit = (targetLimit+targetLimit);
		}
		else {
			var targetDefaultLimit = parseInt(eventsTarget.dataset.defaultlimit);
			eventsTarget.dataset.limit = (targetLimit+targetDefaultLimit);
		}
		cal.loadmore.show(targetBtn.parentNode, 'reset');
	}
	else if (targetBtn.dataset.type == 'reset') {
		eventsTarget.dataset.limit = parseInt(eventsTarget.dataset.defaultlimit);
		eventsTarget.parentNode.scrollIntoView({behavior: 'smooth'});
		cal.loadmore.hide(targetBtn.parentNode, 'reset');
	}
	
	cal.init();
};

cal.loadmore.hide = function(container, btn) {
	// requires target container arg
	container = container.parentNode;
	var targetBtn = container.querySelector('.calevents-loadmore [data-type="'+btn+'"]');
	if (targetBtn) {
		targetBtn.classList.add('hidden');	
	}
};

cal.loadmore.show = function(container, btn) {
	// requires target container arg
	container = container.parentNode;
	console.log(container);
	var targetBtn = container.querySelector('.calevents-loadmore [data-type="'+btn+'"]');
	if (targetBtn) {
		targetBtn.classList.remove('hidden');	
	}
};

if (cal.loadmore.btn.length > 0) {
	for (var i = 0; i < cal.loadmore.btn.length; i++) {
		cal.loadmore.btn[i].addEventListener('click', cal.loadmore.init, false);
	}
};



/* ##################################################################
	GET/SETUP CALENDAR CATEGORIES
################################################################## */

// Prolly Slopsie Joes

cal.cats = {};
cal.cats.url = '/calendar/restfeeds/';

cal.cats.init = function() {

	cal.cats.containers = document.querySelectorAll('.cal-cats');
	cal.cats.resetBtn = document.querySelector('.cal-reset');

	if (cal.cats.containers.length > 0) {

		for (var i = 0; i < cal.cats.containers.length; i++) {

			var args = {};
				args.container = cal.cats.containers[i];
				args.type = cal.cats.containers[i].dataset.type; // eventcats or eventdepts
				args.currentid = cal.cats.containers[i].dataset.current;

			cal.cats.get(args);
		} // for

		cal.cats.resetBtn.addEventListener('click', cal.cats.reset, false);
	}
};

cal.cats.reset = function(e) {
	var targetCalEvents = e.currentTarget.parentNode.nextSibling;

	
	if (targetCalEvents.dataset.defaultlimit != undefined) targetCalEvents.dataset.limit = targetCalEvents.dataset.defaultlimit;

	for (var i = 0, length1 = cal.cats.containers.length; i < length1; i++) {
		var catCont = cal.cats.containers[i];

		switch (catCont.dataset.type) {
			case 'eventdepts':
				targetCalEvents.dataset.department = catCont.dataset.current;
				catCont.value = catCont.dataset.current;
				break;
			case 'eventcats':
				targetCalEvents.dataset.category = catCont.dataset.current;
				catCont.value = catCont.dataset.current;
				break;
			case 'eventmonths':
				if (catCont.dataset.current == 'all') {
					targetCalEvents.dataset.month = '';
					catCont.value = '';
				}
				else {
					targetCalEvents.dataset.month = catCont.dataset.current;
					catCont.value = catCont.dataset.current;
				}
				break;
			default:
				break;
		}
	} // for

	cal.cats.resetBtn.classList.add('hidden');

	cal.init();
};


cal.cats.update = function(e) {

	var targetCalEvents = e.currentTarget.parentNode.nextSibling;

	if (e.currentTarget.dataset.type == 'eventmonths') {
		targetCalEvents.dataset.month = e.currentTarget.value;
	}
	else {
		targetCalEvents.dataset.category = e.currentTarget.value;	
	}
	cal.cats.resetBtn.classList.remove('hidden');
	cal.init();
};

cal.cats.get = function(args) {

	wm.ajax.get(cal.cats.url, {type: args.type}, function() {
		// console.log(this.response);
		if (this.readyState == 4 && this.status == 200 && this.response != null) {
			cal.cats.parse(this.response, args);
		}
	});

};

cal.cats.parse = function(data, args) {

	var items = data;

	// IF IE11
	if (typeof items == 'string') {
		items = JSON.parse(items);
	}

	if (items.length != 0) {

		// Clear any <options>
		args.container.innerHTML = '';

		var nOptionAll = wm.build.elementWithAttributes('option', {value: ''}, 'All');
		args.container.appendChild(nOptionAll);

		if (args.type === 'eventmonths') {

			for (var item in items) {
				var catname = items[item].monthfull + ' (' + items[item].year + ')';
				var catid = items[item].year + '-' + items[item].month; // !!?
				var nOption = wm.build.elementWithAttributes('option', {value: catid}, catname);

				if (args.currentid == catid) {
					nOption.setAttribute('selected', 'selected');
				}
				args.container.appendChild(nOption);
			}
		}
		else {

			for (var i = 0; i < items.length; i++) {

				var catname = items[i].cat_name,
					catid = items[i].term_id;

				var nOption = wm.build.elementWithAttributes('option', {value: catid}, catname);
				
				if (args.currentid == catid) {
					nOption.setAttribute('selected', 'selected');
				}

				// console.log(nOption);

				args.container.appendChild(nOption);

			} // for

		} // if type

		cal.cats.addListeners(args);

	} // if

};

cal.cats.addListeners = function(args) {
	args.container.addEventListener('change', cal.cats.update, false);
};


/* ##################################################################
	INIT IF AVAIL
################################################################## */

if (cal.containers.length > 0) {
	cal.cats.init();
	cal.init();
}

// ====================================================
// Tables
// ====================================================

wm.table = {};


/**
 *
 * WRAP TABLE FOR TABLE-SCROLL-*
 *
 */

wm.table.scrollers = document.querySelectorAll('table');

wm.table.addScroll = function() {
	
	for (var i = 0; i < wm.table.scrollers.length; i++) {
		var classes = 'table-scroll';
		if (wm.table.scrollers[i].classList.contains('horizontal')) classes += ' horizontal';
		if (wm.table.scrollers[i].classList.contains('vertical')) classes += ' vertical';
		var wrapper = wm.build.elementWithAttributes('div', {class: classes}, null);
		wm.build.wrap(wm.table.scrollers[i], wrapper);
	}

};

console.log(document.body.clientWidth);

if (wm.table.scrollers.length > 0 && document.body.clientWidth <= 1024) {
	wm.table.addScroll();
} 
// ====================================================
// TWITTER 
//  - No longer working, twitter API turned off for public use
// ====================================================

wm.tw = {};
wm.tw.url = wm.slug + 'restfeeds/'
wm.tw.params = {
	'type': 'twitter',
	'count': 4
};
wm.tw.container = document.querySelector('.wm-twitterfeed ul');

wm.tw.main = function() {
	wm.tw.fetch();
};

wm.tw.fetch = function() {
	wm.ajax.get(wm.tw.url, wm.tw.params, function(res) {
		wm.tw.build(res.response);
	});
};

wm.tw.build = function(data) {
	// clear container
	wm.tw.container.innerHTML = '';

	for (var i = 0, length1 = data.length; i < length1; i++) {
		var li = document.createElement('li');
		var a = document.createElement('a');
		var span = document.createElement('span');
		
		a.innerText = data[i].post;
		a.href = data[i].url;
		span.innerText = data[i].createdDate;

		li.appendChild(a);
		li.appendChild(span);
		wm.tw.container.appendChild(li);
	}
};


if (wm.tw.container) {
	wm.tw.main();
} // if wm.tw.container
/* ##################################################################
	RSS Module
################################################################## */

wm.rss = {};

wm.rss.main = () => {
	wm.rss.el = {
		containers: document.querySelectorAll('.rssOut')
	};

	console.log(wm.rss.el.containers);

	wm.rss.el.containers.forEach( function(element, index) {
		const ct = element,
			url = element.dataset.url,
			count = Number(element.dataset.count) || 3;

		wm.rss.get(ct, url, count);
	});
	
};

wm.rss.get = (ct, url, count) => {
	url = url || '';

	fetch(url)
  	.then(response => response.text())
		.then(str => new window.DOMParser().parseFromString(str, "text/xml"))
		.then(data => wm.rss.buildOut(ct, data, count))
};

wm.rss.buildOut = (ct, data, count) => {
	ct.innerHTML = ''; // clear first

	// Set title
	if (ct.dataset.title) {
		const rssTitle = document.createElement('h3');
		rssTitle.innerText = ct.dataset.title;
		ct.appendChild(rssTitle);	
	}

	const items = data.querySelectorAll('item');

	items.forEach( function(el, index) {

		if ((index + 1) <= count) {
			const a = document.createElement('a'),
				title = document.createElement('h3'),
				date = document.createElement('span')
				desc = document.createElement('p');
			
			// Link
			a.href = el.querySelector('link').textContent;
			a.target = '_blank';
			a.rel = 'noopener';
			
			//Title
			title.innerText = el.querySelector('title').textContent;
			
			// Date
			date.classList.add('pubDate');
			date.innerText = el.querySelector('pubDate').textContent;
			
			a.appendChild(title);
			a.appendChild(date);
			ct.appendChild(a);
		}

	})
};

wm.rss.main();
